import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { OrganizationProvider, useOrganization } from '../../../context/OrganizationContext';
import { useUser } from '../../../context/UserContext';
import Sidebar from '../common/sidebar';
import TopBar from '../common/topbar';

const PivotPageContent = () => {
  const { organizationId } = useParams();
  const { organizationData, fetchOrganizationData } = useOrganization();
  const { userInfo } = useUser();

  useEffect(() => {
    if (organizationId) {
      fetchOrganizationData(organizationId);
    }
  }, [organizationId, fetchOrganizationData]);

  if (!organizationData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#CC457D] mx-auto mb-4"></div>
          <p className="text-gray-600">Loading organization...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar isOpen={false} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <TopBar />
        
        {/* Pivot Content */}
        <div className="flex-1 p-6 overflow-auto">
          <div className="max-w-7xl mx-auto">
            <div className="bg-white rounded-lg shadow-sm p-8">
              <div className="text-center">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  Pivot Analytics
                </h1>
                <p className="text-lg text-gray-600 mb-8">
                  Interactive data analysis and pivot table functionality
                </p>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                  <p className="text-blue-800">
                    🚧 This page is under construction. Pivot table features will be available soon.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main component that provides the organization context
const PivotPage = () => {
  return (
    <OrganizationProvider>
      <PivotPageContent />
    </OrganizationProvider>
  );
};

export default PivotPage;